<!-- <mat-divider></mat-divider> -->
<h3 class="p-3">{{ "ENTITY.PERSONAL" | translate }}</h3>
<mat-divider class="m-t-5"></mat-divider>
<div class="row m-b-20" *ngIf="patientDetails">
  <div class="col-lg-6">
    <div class="patient-details m-t-10">
      <div
        class="detail-item" *ngIf=" patientDetails.salute || patientDetails.firstName || patientDetails.middleName ||
          patientDetails.lastName
        "
      >
        <label class="opd-label">{{ "LABEL.NAME" | translate }}:</label>
        <span
          >{{ patientDetails.salute }} {{ patientDetails.firstName }}
          {{ patientDetails.middleName }} {{ patientDetails.lastName }}</span
        >
      </div>
      <div class="detail-item" *ngIf="patientDetails.birthDate">
        <label>{{ "LABEL.DATE" | translate }}:</label>
        <span>{{ patientDetails.birthDate | date: "dd-MM-yyyy" }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.age">
        <label>{{ "LABEL.AGE" | translate }}:</label>
        <span>{{ patientDetails.age }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.aadhaarNumber">
        <label>{{ "LABEL.AADHAR" | translate }}:</label>
        <span>{{ patientDetails.aadhaarNumber }}</span>
      </div>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="patient-details m-t-10">
      <div class="detail-item" *ngIf="patientDetails.patientNumber">
        <label>{{ "LABEL.PATIENT_NO" | translate }}:</label>
        <span> {{ patientDetails.patientNumber | defaultValue }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.bloodGroup">
        <label>{{ "LABEL.BLOOD_GROUP" | translate }}:</label>
        <span> {{ patientDetails.bloodGroup | defaultValue }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.bloodPressure">
        <label>{{ "LABEL.BLOOD_PRESURE_LABEL" | translate }}:</label>
        <span>{{ patientDetails.bloodPressure | defaultValue }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.education">
        <label>{{ "LABEL.EDUCATION" | translate }}:</label>
        <span>{{ patientDetails.education | defaultValue }}</span>
      </div>
      <div class="detail-item" *ngIf="patientDetails.registrationDate">
        <label>{{ "LABEL.REGISTRATION_DATE" | translate }}:</label>
        <span> {{ patientDetails.registrationDate | date: "dd-MM-yyyy" }}</span>
      </div>
    </div>
  </div>
</div>
